import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_SALESWARRANTY,
  DELETE_SALESWARRANTY,
  UPDATE_SALESWARRANTY,
  ADD_NEW_SALESWARRANTY,
} from "./actionType";

import {
  getSalesWarrantySuccess,
  getSalesWarrantyFail,
  deleteSalesWarrantySuccess,
  deleteSalesWarrantyFail,
  updateSalesWarrantySuccess,
  updateSalesWarrantyFail,
  addSalesWarrantySuccess,
  addSalesWarrantyFail,
} from "./action";

//Include Both Helper File with needed carriers
import {
  approveSalesWarrantyApi,
  getSalesWarrantyApi,
  updateSalesWarrantyApi,
  deleteSalesWarrantyApi,
  addNewSalesWarrantyApi
} from "../../helpers/backend_helper";

function* getSalesWarranty({ payload: salesWarranty }) {
  try {
    const response = yield call(getSalesWarrantyApi, salesWarranty);
    yield put(getSalesWarrantySuccess(GET_SALESWARRANTY, response.data));
  } catch (error) {
    yield put(getSalesWarrantyFail(GET_SALESWARRANTY, error));
  }
}

function* onUpdateSalesWarranty({ payload: salesWarranty }) {
  try {
    if (salesWarranty.setApprove) {
      const response = yield call(approveSalesWarrantyApi, salesWarranty);
      yield put(updateSalesWarrantySuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateSalesWarrantyApi, salesWarranty);
      yield put(updateSalesWarrantySuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateSalesWarrantyFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteSalesWarranty({ payload: salesWarranty }) {
  try {
    const response = yield call(deleteSalesWarrantyApi, salesWarranty);
    yield put(deleteSalesWarrantySuccess({ salesWarranty, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteSalesWarrantyFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewSalesWarranty({ payload: salesWarranty }) {
  try {
    const response = yield call(addNewSalesWarrantyApi, salesWarranty);
    yield put(addSalesWarrantySuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addSalesWarrantyFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetSalesWarranty() {
  yield takeEvery(GET_SALESWARRANTY, getSalesWarranty);
}

export function* watchUpdateSalesWarranty() {
  yield takeEvery(UPDATE_SALESWARRANTY, onUpdateSalesWarranty);
}

export function* watchDeleteSalesWarranty() {
  yield takeEvery(DELETE_SALESWARRANTY, onDeleteSalesWarranty);
}

export function* watchAddNewSalesWarranty() {
  yield takeEvery(ADD_NEW_SALESWARRANTY, onAddNewSalesWarranty);
}

function* salesWarrantySaga() {
  yield all([
    fork(watchGetSalesWarranty),
    fork(watchDeleteSalesWarranty),
    fork(watchUpdateSalesWarranty),
    fork(watchAddNewSalesWarranty)
  ]);
}

export default salesWarrantySaga;
